export type User = any;

export interface AuthState {
  error?: Error;
  isAuthenticated: boolean;
  isLoading: boolean;
  isInitialized: boolean;
  user?: User;
  userSub?: string;
  userInfo?: User;
  loginDomain?: string;
  updatingClient?: boolean;
}

export const initialAuthState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  isInitialized: false,
  loginDomain: process.env.REACT_APP_AUTH0_DOMAIN,
  updatingClient: false,
};
